export const environment = {
  production: false,
  url: 'https://fusion-api.sunshineteam.ca/api',
  // url: 'https://fusion-api.artechly.com/api',
  API_KEY: 'AIzaSyCkWo7NdSuLWiITkG6kovEY7OKi3plyU8Y'
};

